import { Navigate, useParams } from 'react-router-dom';
import { useFolder } from '@modules/items/api/folders.api';
import { isTFolder } from '@modules/items/types/folders.types';
import { StatusLabel } from '@shared/components/StatusLabel';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle.hook';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import ProjectsContent from '../components/ProjectsContent';
import { useProjectsSettings } from '../hooks/useProjectsSettings.hook';

const Projects = () => {
  const { projectsFolderId } = useParams();
  const { enabled, enabledRootItemTypes } = useProjectsSettings();
  const { data, error } = useFolder(projectsFolderId, { enabled });
  const folder = data && isTFolder(data) ? data : undefined;
  useDocumentTitle(
    folder ? `${TERMINOLOGY.project.upperPlural} · ${folder.resolvedPath[0]?.name}` : TERMINOLOGY.project.upperPlural
  );

  if (!enabled || (folder && !enabledRootItemTypes?.some((type) => type === folder.resolvedPath[0]?.folderType)))
    return <Navigate to="/" replace />;

  return (
    <StatusLabel
      data={folder}
      error={error}
      loadingMessage="Loading workspace..."
      errorMessage="Loading workspace failed!"
      render={(resolved) => <ProjectsContent folder={resolved} />}
    />
  );
};

export default Projects;
